import { useTranslation } from "react-i18next"
import { useGameplayConfig } from "store";
const { storage } = require("services/config/storage");

const CompanyLogo = () => {
    const isOrgWhiteLabelled = storage.get.orgInfo()?.organizationConfig?.moduleFlags?.whitelabel;
    const companyLogo = storage.get.companiesLogos()
    const { t } = useTranslation()
    const { configLanguageSettings } = useGameplayConfig()

    return (
        <div>
            {companyLogo ? (
                <div className="mobile-company-logo flex flex-col items-start">
                    <img src={companyLogo} />
                    {
                        !isOrgWhiteLabelled &&
                        <p className={`color-primary mt-4 flex items-center ${configLanguageSettings.configLanguage !== "en" ? "flex-row-reverse" : "flex-row"}`}>
                            {t("powered_by")} <span className="ml-2 mr-2">unberry</span>
                        </p>
                    }
                </div>
            ) : (
                <>
                    {
                        !isOrgWhiteLabelled && <p className="color-primary font-medium size-34 mb-0">unberry</p>
                    }
                </>
            )}
        </div>
    )
}

export default CompanyLogo